import axios from './axios';

/**
 * 获取用户信息
 * @param {array} params.features 用户白名单
 * @returns
 */
export const getUserBasicInfo = (params: {features: string[]}) => {
    return axios({
        url: 'ticket/v1/account/user',
        method: 'get',
        params: {
            features: params.features.join(','),
        },
    });
};

/**
 * 获取用户站点信息，aipage团队的接口，直接调用的，工单后端不做代理
 */
export const getSiteList = () => {
    return axios({
        url: 'aipage/site/gdSiteList',
        method: 'get',
        params: {
            page: 1,
            perPage: 9999,
        },
    });
};
